import { useEffect, useState } from 'react';
import { getOwnSubjects } from '../../Subject/services/subjectService';

export function useOwnSubjects() {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;

    getOwnSubjects()
      .then((result) => {
        if (mounted) setSubjects(result);
      })
      .catch((err) => {
        if (mounted) setError(err.message || 'Failed to load your subjects');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { subjects, loading, error };
}
